import React from "react";
import { useGuidedTour } from "../GuidedTourProvider";
import { t } from "../i18n";
import styles from "./TourAvatarButton.module.scss";

/**
 * "First steps guide" pill. Click opens the TourListSheet.
 *
 * Two variants:
 *   - default (floating)  → fixed top-right, used as a fallback overlay.
 *   - variant="inline"    → flows in the header next to תמיכה/תזכורות.
 *
 * Hidden during welcome modal / active tour either way.
 */
const TourAvatarButton = ({ variant = "floating" }) => {
  const { openList, welcomeOpen, activeTour, progress } = useGuidedTour();

  if (welcomeOpen || activeTour) return null;

  const allDone =
    progress.services?.completed &&
    progress.workingHours?.completed &&
    progress.calendar?.completed;

  const isInline = variant === "inline";

  if (allDone) {
    return (
      <button
        className={isInline ? styles.doneBtnInline : styles.doneBtn}
        onClick={openList}
        aria-label="Replay guides"
      >
        ✓
      </button>
    );
  }

  return (
    <button
      className={isInline ? styles.buttonInline : styles.button}
      onClick={openList}
    >
      <span
        className={isInline ? styles.memojiInline : styles.memoji}
        role="img"
        aria-label="Guide"
      >👩🏻‍💻</span>
      <span>{t("tours.header.button")}</span>
    </button>
  );
};

export default TourAvatarButton;
